import { gql } from '@apollo/client';

export const getEstablecimientos = gql`
query getEstablecimientos{
    establecimientos(filtros: { codRubro:$rubro, descLocalidad: $localidad, nombre: $denominacion, page:$page,rowCount:$rows,region: $region} , tipo:$tipoBuscador) 
    @rest(type: "Establecimientos", path: "/{args.tipo}/establecimientosvigentes/find?{args.filtros}"){
        total
        muestraLocalidad
        data{
            cuit
            denominacion
            localidad
            rubro
            region
            email
            celular
            contacto
            paginaWeb
            detalleRubro
        }
    }
}`